export enum CustomSettingsItemType {
	YES_NO_FIELD = 'yesNoField',
}
